var app = app || {};
app.config = function () {
    var urls = {
        adminbaseurl: null,
        baseurl: null
    }
    return {
        urls: urls,
    };
}();